import { BaseApiService, apiClient } from 'shared/api/client';

export class OrderService extends BaseApiService {
    constructor() {
        super('/crm/admin-api/orders');
    }

    getStats(token='token') {
        return apiClient.get(`${this.endpoint}/stats`, '', token);
    }

    updateStatus(orderId, status, token='token') {
        return apiClient.patch(`${this.endpoint}/${orderId}/`, { status }, token);
    }

    updateMessage(orderId, message, token='token') {
        return apiClient.patch(`${this.endpoint}/${orderId}/`, { message }, token);
    }
}


export class NotificationTemplateService extends BaseApiService {
    constructor() {
        super('/crm/admin-api/notification-templates');
    }
}

export class NotificationService extends BaseApiService {
    constructor() {
        super('/crm/admin-api/notifications');
    }
}

export const orderService = new OrderService();
export const notificationTemplateService = new NotificationTemplateService();
export const notificationService = new NotificationService();
